<script>
  import siteData from "$data/site_content.aml";
  import { onMount } from "svelte";
  import { createData } from "$utils/data.svelte.js";
  import Chart from "./Chart.svelte";
  import { Block, Meta, Navbar, Headline } from "@urbaninstitute/dataviz-components";
  import { getAbsoluteUrl } from "$utils/urls.js";

  let width = $state(240);

  let toolData = createData();

  onMount(async () => {
    toolData.fetchData();
  });
</script>

<svelte:window bind:innerWidth={width} />

<Meta
  title="american-small-business-trajectories-demo"
  description=""
  publishDate="2025-10-01"
  robotsNoIndex={true}
/>
<Navbar projectUrl={getAbsoluteUrl("")} />
<div class="mt-8">
  <Headline
    headline="The Many Trajectories of American Small Businesses: Preview only"
    date="January 1, 1968"
    eyebrow="Data tool"
    shareUrl="https://urban.org"
  />
</div>

<main>
  {#if Object.values(siteData).length > 0}
    <Block>
      <h3>Microloans Generally Improve Business Outcomes, but Not for Every Entrepreneur</h3>
      <Chart dataFilter="Thriving" showAMetric={false} />
    </Block>
    {#each Object.values(siteData).filter((d) => d.sectionType == "content") as sectionData, i}
      <div style="height: 240px"></div>
      <Block
        ><h3>{sectionData.chartSubtitle}</h3>
        <Chart dataFilter={sectionData.dataFilter} />
      </Block>
    {/each}
  {/if}
</main>

<style>
  main {
    width: 100%;
    max-width: 1160px;
    margin: 0 auto;
  }
</style>
